import React from 'react';
import { useRecoilValue } from 'recoil';
import { displayMorphedState } from 'features/file-browser/state/fileAtoms';
import { isVisibleMorphedState } from 'features/three-view/state/threeAtoms';
import { StlViewer } from '../utils/stlViewer';

export const MorphedViewer: React.FC = () => {
  const displayMorphed = useRecoilValue(displayMorphedState);
  const isVisibleMorphed = useRecoilValue(isVisibleMorphedState);

  if (!displayMorphed.length || !isVisibleMorphed) {
    return <></>;
  }

  const getFileName = (name: string) => {
    return name.split('.').slice(0, -1).join('.');
  };

  return (
    <>
      {displayMorphed.map((s3file, index) => (
        <StlViewer
          key={`${s3file.url}-${index}`}
          url={s3file.url}
          name={getFileName(s3file.name)}
          defaultColor={'#A43DA5'}
          label={'Morphed'}
        />
      ))}
    </>
  );
};
